











import { createComponent, toRefs } from "@vue/composition-api";
import { useNumericFieldFunctions } from "@web-components/compositions/useNumericFieldFunctions";
import { usePreventNonNumeric } from "@web-components/compositions/usePreventNonNumeric";
//eslint-disable-next-line
import { NumericFieldProps } from "@web-components/types/NumericFieldProps";

export default createComponent({
  inheritAttrs: false,
  props: {
    min: {
      type: Number,
      required: true
    },
    max: {
      type: Number,
      required: true
    },
    value: {
      type: [Number, String],
      required: false
    }
  },
  setup(props: Readonly<NumericFieldProps>, context) {
    const numericData = useNumericFieldFunctions(props, context);

    const { onKeyDown } = usePreventNonNumeric(props.max);
    return {
      onKeyDown,
      ...toRefs(numericData)
    };
  }
});
